import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
 
import { DealsService } from './deals.service';
 
@Injectable({
  providedIn: 'root'
})
export class DealssingleResolverService  {
  constructor(private product: DealsService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.product.getDealsSingle().pipe(
      catchError(error => {
        return of('No data');
      })
    );
  }
}

